export default __webpack_public_path__ + "static/media/tempoSettings.909fec41.png";